import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const deleteAuthoringAmends = api(async function deleteAuthoringAmends({ projectId, amendsId }) {
    return mutate(
        gql`
            mutation DeleteAuthoringAmends($projectId: String!, $amendsId: String!) {
                deleteAuthoringAmends(projectId: $projectId, amendsId: $amendsId)
            }
        `,
        {
            projectId,
            amendsId,
        },
        { returns: "deleteAuthoringAmends" }
    )
})
